/**
 * Websocket event names.
 * Mirror of CAE-BACKEND/socket/events.js — keep both files in sync.
 */
const SOCKET_EVENTS = {
  // connection lifecycle
  CONNECTED: "connection:ready",
  ERROR: "socket:error",

  // presence / online indicator
  PRESENCE_GET: "presence:get",
  PRESENCE_LIST: "presence:list",
  PRESENCE_ONLINE: "presence:online",
  PRESENCE_OFFLINE: "presence:offline",

  // room management
  CHAT_JOIN: "chat:join",
  CHAT_LEAVE: "chat:leave",

  // messaging
  MESSAGE_SEND: "message:send",
  MESSAGE_ACK: "message:ack",
  MESSAGE_NEW: "message:new",
  MESSAGE_EDITED: "message:edited",
  MESSAGE_DELETED: "message:deleted",
  MESSAGES_CLEARED: "message:cleared",

  // ticks
  MESSAGE_DELIVERED: "message:delivered",
  MESSAGE_SEEN: "message:seen",
  MESSAGE_STATUS: "message:status",

  // typing indicator
  TYPING_START: "typing:start",
  TYPING_STOP: "typing:stop",

  // unread counters
  UNREAD_SYNC: "unread:sync",
  UNREAD_UPDATE: "unread:update",

  // chat lifecycle
  CHAT_CREATED: "chat:created",
  CHAT_UPDATED: "chat:updated",
  CHAT_DELETED: "chat:deleted",
  CHAT_PINNED: "chat:pinned",

  // real-time cache sync
  DATA_INVALIDATED: "data:invalidated",

  // student chat
  STUDENT_CHAT_JOIN: "student_chat:join",
  STUDENT_CHAT_LEAVE: "student_chat:leave",
  STUDENT_CHAT_MESSAGE_SEND: "student_chat:message:send",
  STUDENT_CHAT_MESSAGE_NEW: "student_chat:message:new",
  STUDENT_CHAT_MESSAGE_SEEN: "student_chat:message:seen",
  STUDENT_CHAT_UNREAD_UPDATE: "student_chat:unread:update",

  // student notes
  STUDENT_NOTES_JOIN: "student_notes:join",
  STUDENT_NOTES_LEAVE: "student_notes:leave",
  STUDENT_NOTES_NEW: "student_notes:new",
  STUDENT_NOTES_DELETED: "student_notes:deleted",

  // student seen status
  STUDENT_IS_NEW_UPDATE: "student:is_new:update",

  // student pin status
  STUDENT_PINNED_UPDATE: "student:pinned:update",
};




export const MESSAGE_STATUS = {
  SENDING: "sending", // optimistic, not acknowledged yet
  SENT: "sent", // single tick
  DELIVERED: "delivered", // double tick
  SEEN: "seen", // blue double tick
  FAILED: "failed",
};

export default SOCKET_EVENTS;
